import replace from 'lodash-es/replace';
import $store from '../store';

export default (value) => {
  if ($store.state.filters.reverseTextForLocals.includes($store.state.locale)) {
    const englishDigits = { '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4', '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9' };
    return replace(value, /[۰۱۲۳۴۵۶۷۸۹]/g, s => englishDigits[s]);
  }
  return value;
};



// WEBPACK FOOTER //
// ./src/filter/number-conversion.js